import React, {useEffect, useState} from "react";

const AutoPromoAddSenseBanners = ({autoPromoBannersHtmlContent}) => {
    const [isShown, setIsShown] = useState(false);
    useEffect(() => {
        setIsShown(autoPromoBannersHtmlContent ? true : false);
    }, [autoPromoBannersHtmlContent]);

    return (
        <div className="dp__products__promoAddSenseBanners" style={{display: isShown ? "block" : "none"}}>
            <div dangerouslySetInnerHTML={{__html: autoPromoBannersHtmlContent}}/>
        </div>
    );
};

export default AutoPromoAddSenseBanners;